function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '');
}

export let API_BASE_URL = '';

export async function loadAppConfig() {
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  const response = await fetch(`${publicUrl}/appsettings.json`, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Unable to load appsettings.json (${response.status}).`);
  }
  const settings = await response.json();
  if (typeof settings?.api?.baseUrl !== 'string') {
    throw new Error('appsettings.json must contain api.baseUrl as a string.');
  }
  API_BASE_URL = trimTrailingSlash(settings.api.baseUrl.trim());
}

export function assetUrl(path?: string | null) {
  if (!path) return null;

  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      if (url.hostname.endsWith('.ngrok-free.app') && url.pathname.startsWith('/uploads/')) {
        return `${url.pathname}${url.search}${url.hash}`;
      }
    } catch {
      return path;
    }

    return path;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (normalized.startsWith('/uploads/')) {
    return `${API_BASE_URL}${normalized}`;
  }

  if (normalized.startsWith('/demo-art/') || normalized.startsWith('/point-art-bg-')) {
    return normalized;
  }

  return `${API_BASE_URL}${normalized}`;
}
